export default function Home() {
  return (
    // This is the template home page, please edit from this page
    <div className="flex flex-col items-center pt-8">
    </div>
  );
}